/* eslint-disable max-len */
export const DATA_TABLE_SOURCE_ADMIN_TOURS = 'DATA_TABLE_SOURCE_ADMIN_TOURS';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_PENDING = 'DATA_TABLE_VIEW_ID_ADMIN_TOURS_PENDING';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_PENDING_CONFIRMATION =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_PENDING_CONFIRMATION';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_NEEDS_RESCHEDULING =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_NEEDS_RESCHEDULING';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED = 'DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED = 'DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED_INDICATOR =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED_INDICATOR';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED = 'DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNASKED =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNASKED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNANSWERED =
  'DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNANSWERED';
export const DATA_TABLE_VIEW_ID_ADMIN_TOURS_ALL = 'DATA_TABLE_VIEW_ID_ADMIN_TOURS_ALL';

export const DATA_TABLE_SOURCE_USER_BOOKMARKS = 'DATA_TABLE_SOURCE_USER_BOOKMARKS';
export const DATA_TABLE_VIEW_ID_USER_BOOKMARKS_DEFAULT =
  'DATA_TABLE_VIEW_ID_USER_BOOKMARKS_DEFAULT';

export const DATA_TABLE_SOURCE_HOUSEHOLD_DASHBOARD = 'DATA_TABLE_SOURCE_HOUSEHOLD_DASHBOARD';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_REQUESTED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_REQUESTED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_STARTED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_STARTED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_COMPLETED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_COMPLETED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_PAID =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_PAID';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_DELIVERED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_DELIVERED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_ACCEPTED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_APPLICATION_ACCEPTED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_LEASE_SIGNED =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_LEASE_SIGNED';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_ALL =
  'DATA_TABLE_VIEW_ID_HOUSEHOLD_DASHBOARD_ALL';

export const DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN = 'DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN';
export const DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN_APPLICATION_COLUMN =
  'DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN_APPLICATION_COLUMN';
export const DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN_TOURING =
  'DATA_TABLE_SOURCE_HOUSEHOLD_KANBAN_TOURING';

export const DATA_TABLE_SOURCE_GOING_TO_MARKET_V2_LISTINGS =
  'DATA_TABLE_SOURCE_GOING_TO_MARKET_V2_LISTINGS';
export const DATA_TABLE_VIEW_ID_GOING_TO_MARKET_V2_LISTINGS_ALL =
  'DATA_TABLE_VIEW_ID_GOING_TO_MARKET_V2_LISTINGS_ALL';
export const DATA_TABLE_VIEW_ID_GOING_TO_MARKET_V2_LISTINGS_TEMP_OFF =
  'DATA_TABLE_VIEW_ID_GOING_TO_MARKET_V2_LISTINGS_TEMP_OFF';

export const DATA_TABLE_SOURCE_AGENT_LEADS = 'DATA_TABLE_SOURCE_AGENT_LEADS';

export const DATA_TABLE_SOURCE_RENTER_FEED = 'DATA_TABLE_SOURCE_RENTER_FEED';
export const DATA_TABLE_VIEW_ID_RENTER_FEED_APARTMENT_LOCATOR =
  'DATA_TABLE_VIEW_ID_RENTER_FEED_APARTMENT_LOCATOR';
export const DATA_TABLE_VIEW_ID_RENTER_FEED_LEAD = 'DATA_TABLE_VIEW_ID_RENTER_FEED_LEAD';

export const DATA_TABLE_SOURCE_FRONT_AUTO_TEXTS = 'DATA_TABLE_SOURCE_FRONT_AUTO_TEXTS';

export const DATA_TABLE_SOURCE_INVOICES = 'DATA_TABLE_SOURCE_INVOICES';

export const DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS = 'DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS';
export const DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL =
  'DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL';

export const DATA_TABLE_SOURCE_PARTNER_APARTMENTS = 'DATA_TABLE_SOURCE_PARTNER_APARTMENTS';
export const DATA_TABLE_VIEW_ID_PARTNER_APARTMENTS_ALL =
  'DATA_TABLE_VIEW_ID_PARTNER_APARTMENTS_ALL';
export const DATA_TABLE_VIEW_ID_PARTNER_APARTMENTS_APP_IN_PROGRESS =
  'DATA_TABLE_VIEW_ID_PARTNER_APARTMENTS_APP_IN_PROGRESS';

export const DATA_TABLE_SOURCE_PARTNER_LISTINGS = 'DATA_TABLE_SOURCE_PARTNER_LISTINGS';
export const DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_ALL = 'DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_ALL';
export const DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TENANT_SCREENING =
  'DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TENANT_SCREENING';
export const DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_APP_IN_PROGRESS =
  'DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_APP_IN_PROGRESS';

export const DATA_TABLE_SOURCE_PARTNER_LISTINGS_TABLE = 'DATA_TABLE_SOURCE_PARTNER_LISTINGS_TABLE';
export const DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TABLE =
  'DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TABLE';

export const DATA_TABLE_SOURCE_PARTNER_MARKET_CONFIGURATIONS =
  'DATA_TABLE_SOURCE_PARTNER_MARKET_CONFIGURATIONS';
export const DATA_TABLE_VIEW_ID_PARTNER_MARKET_CONFIGURATIONS =
  'DATA_TABLE_VIEW_ID_PARTNER_MARKET_CONFIGURATIONS';

export const DATA_TABLE_SOURCE_ADMIN_LISTINGS_LIST = 'DATA_TABLE_SOURCE_ADMIN_LISTINGS_LIST';
export const DATA_TABLE_VIEW_ID_ADMIN_LISTINGS_LIST_SUNROOM =
  'DATA_TABLE_VIEW_ID_ADMIN_LISTINGS_LIST_SUNROOM';

export const DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS =
  'DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS';
export const DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_ALL =
  'DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_ALL';
export const DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_WITHDRAWN =
  'DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_WITHDRAWN';
export const DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_TEMP_OFF_MARKET =
  'DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_TEMP_OFF_MARKET';
export const DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_REFERRAL =
  'DATA_TABLE_VIEW_ID_MARKETING_PARTNER_LISTINGS_REFERRAL';

export const DATA_TABLE_SOURCE_PARTNER_LISTING_TOUR_REVIEWS =
  'DATA_TABLE_SOURCE_PARTNER_LISTING_TOUR_REVIEWS';
export const DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES =
  'DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES';

export const DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA =
  'DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA';
export const DATA_TABLE_VIEW_ID_TENANT_SCREENING_CRITERIA_ALL =
  'DATA_TABLE_VIEW_ID_TENANT_SCREENING_CRITERIA_ALL';

export const DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS = 'DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS';
export const DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_PENDING_APPROVALS =
  'DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_PENDING_APPROVALS';
export const DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_MOVE_INS =
  'DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_MOVE_INS';

export const DATA_TABLE_SOURCE_APARTMENTS = 'DATA_TABLE_SOURCE_APARTMENTS';
export const DATA_TABLE_VIEW_ID_APARTMENTS_ALL = 'DATA_TABLE_VIEW_ID_APARTMENTS_ALL';
export const DATA_TABLE_VIEW_ID_APARTMENT_BY_ID = 'DATA_TABLE_VIEW_ID_APARTMENT_BY_ID';

export const DATA_TABLE_SOURCE_PARTNER_STATS_TOURS = 'DATA_TABLE_SOURCE_PARTNER_STATS_TOURS';
export const DATA_TABLE_SOURCE_PARTNER_STATS_RENTLINX_LEADS =
  'DATA_TABLE_SOURCE_PARTNER_STATS_RENTLINX_LEADS';
export const DATA_TABLE_SOURCE_PARTNER_STATS_SUPRA_SHOWINGS =
  'DATA_TABLE_SOURCE_PARTNER_STATS_SUPRA_SHOWINGS';

export const DATA_TABLE_SOURCE_ADMIN_PARTNERS = 'DATA_TABLE_SOURCE_ADMIN_PARTNERS';
export const DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_ALL = 'DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_ALL';
export const DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_REVIEW = 'DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_REVIEW';

export const DATA_TABLE_SOURCE_MEDIA = 'DATA_TABLE_SOURCE_MEDIA';
export const DATA_TABLE_VIEW_ID_MEDIA_BY_ID = 'DATA_TABLE_VIEW_ID_MEDIA_BY_ID';
export const DATA_TABLE_VIEW_ID_MEDIA_BY_FOREIGN_ID = 'DATA_TABLE_VIEW_ID_MEDIA_BY_FOREIGN_ID';

export const DATA_TABLE_SOURCE_PARTNER_SALES = 'DATA_TABLE_SOURCE_PARTNER_SALES';
export const DATA_TABLE_VIEW_ID_PARTNER_SALES_ALL = 'DATA_TABLE_VIEW_ID_PARTNER_SALES_ALL';

export const DATA_TABLE_SOURCE_HOUSEHOLD_NOTES = 'DATA_TABLE_SOURCE_HOUSEHOLD_NOTES';
export const DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL = 'DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL';

export const DATA_TABLE_SOURCE_PARTNER_NOTES = 'DATA_TABLE_SOURCE_PARTNER_NOTES';
export const DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL = 'DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL';

export const DATA_TABLE_SOURCE_RENTLINX_LEADS = 'DATA_TABLE_SOURCE_RENTLINX_LEADS';
export const DATA_TABLE_VIEW_ID_RENLINX_LEADS_ACTIVE = 'DATA_TABLE_VIEW_ID_RENLINX_LEADS_ACTIVE';
export const DATA_TABLE_VIEW_ID_RENLINX_LEADS_ARCHIVED =
  'DATA_TABLE_VIEW_ID_RENLINX_LEADS_ARCHIVED';

export const DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES = 'DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES';
export const DATA_TABLE_VIEW_ID_RENTLINX_LEAD_NOTES_ALL =
  'DATA_TABLE_VIEW_ID_RENTLINX_LEAD_NOTES_ALL';
export const DATA_TABLE_VIEW_ID_RENTLINX_LEAD_NOTES_BY_LISTING_ID =
  'DATA_TABLE_VIEW_ID_RENTLINX_LEAD_NOTES_BY_LISTING_ID';

export const DATA_TABLE_SOURCE_STRIPE_CHARGES = 'DATA_TABLE_SOURCE_STRIPE_CHARGES';
export const DATA_TABLE_VIEW_ID_STRIPE_CHARGES = 'DATA_TABLE_VIEW_ID_STRIPE_CHARGES';

export const DATA_TABLE_SOURCE_LISTING_LEAD_HEALTH = 'DATA_TABLE_SOURCE_LISTING_LEAD_HEALTH';
export const DATA_TABLE_VIEW_ID_LISTING_LEAD_HEALTH = 'DATA_TABLE_VIEW_ID_LISTING_LEAD_HEALTH';

export const DATA_TABLE_SOURCE_LISTING_NOTES = 'DATA_TABLE_SOURCE_LISTING_NOTES';
export const DATA_TABLE_SOURCE_JOB_ORDER_NOTES = 'DATA_TABLE_SOURCE_JOB_ORDER_NOTES';
export const DATA_TABLE_VIEW_ID_JOB_ORDER_NOTES = 'DATA_TABLE_VIEW_ID_JOB_ORDER_NOTES';
export const DATA_TABLE_VIEW_ID_LISTING_NOTES_ALL = 'DATA_TABLE_VIEW_ID_LISTING_NOTES_ALL';
export const DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER =
  'DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER';

export const DATA_TABLE_SOURCE_SUNSETUP_COMPLETED_SETUPS =
  'DATA_TABLE_SOURCE_SUNSETUP_COMPLETED_SETUPS';

export const DATA_TABLE_SOURCE_SUNSETUP_WITHDRAWNS = 'DATA_TABLE_SOURCE_SUNSETUP_WITHDRAWNS';

export const DATA_TABLE_SOURCE_REDIRECTIONS = 'DATA_TABLE_SOURCE_REDIRECTIONS';
export const DATA_TABLE_VIEW_ID_REDIRECTIONS = 'DATA_TABLE_VIEW_ID_REDIRECTIONS';

export const DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS = 'DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS';
export const DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS =
  'DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS';
export const DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS =
  'DATA_TABLE_VIEW_ID_SUNSETUP_LISTING_ORDERS';

export const DATA_TABLE_SOURCE_SUNLIGHT_SEARCH_LISTINGS =
  'DATA_TABLE_SOURCE_SUNLIGHT_SEARCH_LISTINGS';
export const DATA_TABLE_VIEW_ID_SUNLIGHT_SEARCH_LISTINGS =
  'DATA_TABLE_VIEW_ID_SUNLIGHT_SEARCH_LISTINGS';

export const DATA_TABLE_SOURCE_SUNLIGHT_SEARCH_PARTNERS =
  'DATA_TABLE_SOURCE_SUNLIGHT_SEARCH_PARTNERS';
export const DATA_TABLE_VIEW_ID_SUNLIGHT_SEARCH_PARTNERS =
  'DATA_TABLE_VIEW_ID_SUNLIGHT_SEARCH_PARTNERS';

export const DATA_TABLE_SOURCE_LISTING_CONCESSIONS_HISTORY =
  'DATA_TABLE_SOURCE_LISTING_CONCESSIONS_HISTORY';
export const DATA_TABLE_VIEW_ID_LISTING_CONCESSIONS_HISTORY =
  'DATA_TABLE_VIEW_ID_LISTING_CONCESSIONS_HISTORY';

export const DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS_PER_MARKET =
  'DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS_PER_MARKET';
export const DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS_PER_MARKET =
  'DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS_PER_MARKET';

export const DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS =
  'DATA_TABLE_SOURCE_SUNSETUP_INVENTORY_ITEMS';
export const DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS =
  'DATA_TABLE_VIEW_ID_SUNSETUP_INVENTORY_ITEMS';

export const DATA_TABLE_SOURCE_LISTING_CMA_HISTORY = 'DATA_TABLE_SOURCE_LISTING_CMA_HISTORY';
export const DATA_TABLE_VIEW_ID_LISTING_CMA_HISTORY = 'DATA_TABLE_VIEW_ID_LISTING_CMA_HISTORY';

export const DATA_TABLE_SOURCE_LISTING_LEADS = 'DATA_TABLE_SOURCE_LISTING_LEADS';

export const DATA_TABLE_SOURCE_SUNSETUP_DRIVERS = 'DATA_TABLE_SOURCE_SUNSETUP_DRIVERS';
export const DATA_TABLE_VIEW_ID_SUNSETUP_DRIVERS = 'DATA_TABLE_VIEW_ID_SUNSETUP_DRIVERS';

// Utility Profit
export const DATA_TABLE_SOURCE_UTILITY_ACTIVATIONS = 'DATA_TABLE_SOURCE_UTILITY_ACTIVATIONS';
export const DATA_TABLE_SOURCE_UTILITY_PARTNERS = 'DATA_TABLE_SOURCE_UTILITY_PARTNERS';
export const DATA_TABLE_SOURCE_UTILITY_PARTNER_USERS = 'DATA_TABLE_SOURCE_UTILITY_PARTNER_USERS';
export const DATA_TABLE_SOURCE_UTILITY_PARTNER_NOTES = 'DATA_TABLE_SOURCE_UTILITY_PARTNER_NOTES';
export const DATA_TABLE_SOURCE_UTILITY_ACTIVATION_NOTES =
  'DATA_TABLE_SOURCE_UTILITY_ACTIVATION_NOTES';
export const DATA_TABLE_SOURCE_UTILITY_ACTIVATION_FILES =
  'DATA_TABLE_SOURCE_UTILITY_ACTIVATION_FILES';
export const DATA_TABLE_SOURCE_UTILITY_PARTNER_ADDRESSES =
  'DATA_TABLE_SOURCE_UTILITY_PARTNER_ADDRESSES';
export const DATA_TABLE_SOURCE_UTILITY_ORDERS_HITLIST = 'DATA_TABLE_SOURCE_UTILITY_ORDERS_HITLIST';
export const DATA_TABLE_SOURCE_UTILITY_MAPPING_HITLIST =
  'DATA_TABLE_SOURCE_UTILITY_MAPPING_HITLIST';
export const DATA_TABLE_SOURCE_UTILITY_MAPPING_DEFAULTS =
  'DATA_TABLE_SOURCE_UTILITY_MAPPING_DEFAULTS';
export const DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUPS =
  'DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUPS';
export const DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUP_INDEX =
  'DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUP_INDEX';
export const DATA_TABLE_SOURCE_PURCHASE_REQUESTS = 'DATA_TABLE_SOURCE_PURCHASE_REQUESTS';
export const DATA_TABLE_SOURCE_NON_INTERNET_INVOICES = 'DATA_TABLE_SOURCE_NON_INTERNET_INVOICES';
export const DATA_TABLE_SOURCE_TENANT_BULK_IMPORT_SYNCS_FROM_GMAIL =
  'DATA_TABLE_SOURCE_TENANT_BULK_IMPORT_SYNCS_FROM_GMAIL';
export const DATA_TABLE_SOURCE_AUTOMATIC_ORDERS = 'DATA_TABLE_SOURCE_AUTOMATIC_ORDERS';
export const DATA_TABLE_SOURCE_AUTOMATIC_ORDERS_DETAILS =
  'DATA_TABLE_SOURCE_AUTOMATIC_ORDERS_DETAILS';

// These are already migrated to UP
export const DATA_TABLE_SOURCE_UTILITY_PARTNER_PMS_INTEGRATIONS =
  'DATA_TABLE_SOURCE_UTILITY_PARTNER_PMS_INTEGRATIONS';

/* eslint-enable max-len */
